import React, { useState, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { useParams } from 'react-router-dom';
import * as Style from './style';
import Card from '../../../../components/Campanhas/Card';
import { CampaignHeaderWithLinks } from '../../../../components/Campanhas/CampaignHeader';
import Summary from '../../../../components/Campanhas/Summary';

import { LoaderFull } from '../../../../components/Loader';

import Utils from '../../../../services/utils';
import api from '../../../../services/api';

export const CampaignTypes = {
	carregando: 'loading',
	pontual: 'pontual',
	recorrente: 'recorrente',
};

const CARREGANDO = 'Carregando...';

const RecurrentCampaignDetails = () => {
	const { campaignId } = useParams();
	const [campaignType, setCampaignType] = useState(CampaignTypes.carregando);

	const [investment, setInvestment] = useState(CARREGANDO);
	const [selectedChannel, setSelectedChannel] = useState(CARREGANDO);
	const [campaignObjective, setCampaignObjective] = useState(CARREGANDO);
	const [locations, setLocation] = useState(CARREGANDO);
	const [logoName, setLogo] = useState(CARREGANDO);
	const [hiredDate, setHiredDate] = useState(CARREGANDO);
	const [status, setStatus] = useState(CARREGANDO);

	const [fileName] = useState('Lista_1000_clientes.xml');
	const [prospectionClients] = useState(1000);
	const [aprovedClients] = useState(300);
	const [recentLeadClients] = useState(500);
	const [newClients] = useState(200);


	useEffect(() => {
		TagManager.dataLayer({
			dataLayer: {
				event: 'PageView',
				page: 'Detalhes campanha',
			},
			dataLayerName: 'Campanhas',
		});
	}, []);


	const AnswersActions = {
		channel: answer => setSelectedChannel(answer),
		value: answer => setInvestment(Utils.currencyFormatter(answer, 1)),
		objective: answer => setCampaignObjective(answer),
	};

	const mapReachToLocation = unfilteredLocations => (
		unfilteredLocations.map(location => location.city)
	);

	useEffect(() => {
		api.get(`/api/v2/briefings/${campaignId}`)
			.then((response) => {
				setLogo(response.data.data.attributes.logo);
				setHiredDate(response.data.data.attributes.date);
				setStatus(response.data.data.attributes.status);
				setLocation(mapReachToLocation(response.data.data.attributes.reach));
				setCampaignType(CampaignTypes[response.data.data.attributes.type]);
				response.data.data.relationships.answers.forEach(
					answer => AnswersActions[answer.attributes.alias]
						&& AnswersActions[answer.attributes.alias](answer.attributes.content),
				);
			});
	}, []);

	return (
		<div style={{ padding: '30px 38px 0' }}>
			<CampaignHeaderWithLinks>Minhas campanhas - Detalhes</CampaignHeaderWithLinks>
			<Card padding="30px 30px">
				<h3>Detalhes da campanha recorrente</h3>
				<Style.Info role="table">
					<div role="cell">
						<span>ID Campanha</span>
						<em>{campaignId}</em>
					</div>
					<div role="cell">
						<span>Contratada em</span>
						<em>{hiredDate}</em>
					</div>
					<div role="cell">
						<span>Valor</span>
						<em>{investment}</em>
					</div>
					<div role="cell">
						<span>Campanha</span>
						<em>{selectedChannel}</em>
					</div>
					<div role="cell">
						<span>Status</span>
						<em>{status}</em>
					</div>
				</Style.Info>
				<div>
					{ campaignType === CampaignTypes.carregando && (
					<div>
						<LoaderFull />
					</div>
							)}
					{ campaignType !== CampaignTypes.carregando && (
					<Summary
						selectedChannel={selectedChannel}
						campaignObjective={campaignObjective}
						logoName={logoName}
						locations={locations}
						campaignInvestment={investment}
						fileName={fileName}
						prospectionClients={prospectionClients}
						aprovedClients={aprovedClients}
						recentLeadClients={recentLeadClients}
						newClients={newClients}
						campaignType={campaignType}
					/>
							)}
				</div>
			</Card>
		</div>
	);
};

export default RecurrentCampaignDetails;
